angular.module('unica_invitation_transfer.invitation_transfer_services')

.factory('InvitationTransferEditService', function ($http, getBaseApiURL) {

	var invitationTransferEditService = {};

	invitationTransferEditService.update = function (invitationTransferData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer/update/' + invitationTransferData.id,
			data: invitationTransferData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_transfer;
			}

		});

	};

	return invitationTransferEditService;
});